import * as React from 'react';
import * as ProjectsListStore from '../../store/ProjectsListStore';
import * as ResourcesListStore from '../../store/ResourcesListStore';
import * as TimeReportingPeriodsStore from '../../store/TimeReportingPeriodsStore';
import * as Notifications from "../../store/NotificationsStore";
import * as ViewsStore from '../../store/views';
import * as WarningsTypeMapsStore from "../../store/warningsTypeMapsStore";
import * as LayoutsStore from '../../store/layouts';
import * as Metadata from '../../entities/Metadata';
import {
    EntityType, Dictionary, ISourceInfo, PpmxConnection, IInsightsData, ppmxTaskConnectionId,
    IWarning, IPatch, StatusCategory, Sections, Quantization,
    ITimeframe, UpdateOptions, TaskType, ModeSwitchRecalculation
} from '../../entities/common';
import { RouteComponentProps } from "react-router-dom";
import * as TasksSummaryControl from '../common/sectionsControl/uiControls/TasksSummaryControl';
import * as TasksControl from '../common/sectionsControl/uiControls/TasksControl';
import { DetailsSpinner } from '../common/Spinner';
import { connect } from 'react-redux';
import { warningService } from '../../store/services/warningService';
import { ApplicationState, BoundActionCreators, bindThunkActionCreators } from '../../store';
import { bindActionCreators } from 'redux';
import ExternalEpmConnectControl from '../project/ExternalEpmConnectControl';
import { SectionsContainer } from '../common/sectionsControl/SectionsContainer';
import { isLiteModel, toDate } from '../utils/common';
import { ISubentitiesListSettings } from '../common/SubentitiesList';
import { buildAttachmentActions, ITask, ITaskAttrs } from '../../entities/Subentities';
import * as Groups from '../../store/groups';
import { nameof } from '../../store/services/metadataService';
import { Insights, Subscription, PPMFeatures, TimeTrackingGlobalSettings } from '../../store/Tenant';
import { validatorsBuilder, rendersBuilder, inlineRendersBuilder, inlineValidatorsBuilder, buildDeriveDisplayAttributes, buildTaskSavePayload } from './Fields';
import { fetchTaskAssignmentShares } from './taskFetchers';
import { calculateDueDate } from '../utils/duration';
import { BaselineFakeFields } from '../views/list/columns/task/Baseline';
import { SourceType } from '../../store/ExternalEpmConnectStore';
import { ICreationData } from '../../store/Subentity';
import { IControlConfiguration } from '../common/interfaces/ISectionUIControlProps';
import { Views } from '../../store/services/viewSaver';
import { ViewTypeViews, buildUrlViewTypeHeaderRender, viewTypeSettingsBuilder } from '../common/ViewTypeSelect';
import { mergeDefault } from '../../store/utils';
import { CalculationModeFakeField } from '../views/list/columns/task/Mode';
import { TaskTypeFakeField } from '../views/list/columns/task/TaskType';
import { getTaskReadonlyFields } from '../mywork/TaskEditPanel';
import { actionCreators as UserInterfaceActionCreators } from '../../store/UserInterfaceStore';
import * as StatusDescriptorFactory from '../../entities/StatusDescriptorFactory';
import * as MondayComStore from '../../store/integration/MondayComStore';
import { CreateTimeTrackingEntryAttr, actionCreators as TimeTrackingActionCreators } from "../../store/TimeTrackingStore";
import ProjectHeader from '../project/ProjectHeader';
import { UserState } from '../../store/User';
import { IsSummaryFakeField } from '../views/list/columns/task/IsSummary';
import CopyScheduleConfirmationDialog from '../common/CopyScheduleConfirmationDialog';
import { ExtensionInfo, ExtensionPageLocation, findExtension } from '../../store/ExtensionStore';
import { AssignmentByDayUpdate } from '../../store/tasks';
import { EventType } from '../../store/SignalRStore';
import WithSignalR from '../common/withSignalR';
import { DAYS_IN_WEEK } from '../common/timeline/utils';
import { findScheduleControl, getEditedLayout } from './ConfigureTaskForm';
import { TASK_FORM_SETTINGS } from '../common/sectionsControl/uiControls/scheduleControl/sourceSettings';
import { CalendarDataSet } from '../../store/calendar/common';
import { getSourceInfoFromUrl, getViewTypeFromUrl, isWorkloadSourceChanged } from './taskViewUrl';

export type StateProps = {
    projectFields: Metadata.Field[];
    taskFields: Metadata.Field[];
    entity?: ProjectsListStore.ProjectInfo;
    insights: Insights;
    warnings?: IWarning[];
    warningsTypeMap?: WarningsTypeMapsStore.EntityWarningsTypeMap;
    groups: Metadata.Group[] | undefined;
    isLoading: boolean;
    shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay: boolean;
    calendar: CalendarDataSet;
    resources: Dictionary<ResourcesListStore.Resource>;
    calendarsById: Dictionary<CalendarDataSet>;
    hasArchiveProjects: boolean;
    timeTrackingSettings: TimeTrackingGlobalSettings;
    user: UserState;
    extensions?: ExtensionInfo[];
    layouts: LayoutsStore.LayoutsState;
};
export type ActionProps = {
    taskViewsActions: ReturnType<typeof ViewsStore.actionCreators.forEntity>;
    projectsActions: BoundActionCreators<typeof ProjectsListStore.actionCreators>;
    timeReportingPeriodsActions: typeof TimeReportingPeriodsStore.actionCreators;
    notificationsActions: typeof Notifications.actionCreators;
    warningsTypeMapsActions: typeof WarningsTypeMapsStore.actionCreators;
    groupsActions: ReturnType<typeof Groups.actionCreators.forEntity>;
    layoutsActions: ReturnType<typeof LayoutsStore.actionCreators.forEntity>;
    userInterfaceActions?: typeof UserInterfaceActionCreators;
    mondayComActions: typeof MondayComStore.actionCreators;
    timeTrackingActions?: typeof TimeTrackingActionCreators;
};
type Props = StateProps
    & ActionProps
    & RouteComponentProps<{ id: string }>;
type State = {
    isCofigurationPanelOpen?: boolean;
    activeSourceInfo: ISourceInfo;
    scheduleToCopy?: SourceType;
    /** Bug 17380 – per-assignee stored Effort, by task id, for the tasks the edit panel has asked about. */
    assignmentShares?: Dictionary<Dictionary<number>>;
}
const tasksSectionSettings: ISubentitiesListSettings = {
    displayFields: [],
    orderBy: [],
    timeline: {
        displayFields: []
    }
};

const tasksControlType: string = 'TasksControl';
const sections: Metadata.Section[] = [{
    id: '8ef51ed2-6b9a-4091-bed6-c7b075329df4',
    isOpen: true,
    isSelected: true,
    isAccessible: true,
    name: 'Summary',
    settings: { iconName: 'PPMXSectionSummary' },
    uiControls: [{
        id: '8d56abdb-2acd-4300-9b59-9f1296a3dd8a',
        type: 'TasksSummaryControl',
        settings: {}
    }]
}, {
    id: Sections.ProjectTasksSectionId,
    isOpen: true,
    isSelected: true,
    isAccessible: true,
    name: 'Tasks',
    settings: { iconName: 'TaskManager' },
    uiControls: [{
        id: 'f2ee84be-b931-43db-ab9e-6dbf7f0fc5b7',
        type: tasksControlType,
        settings: tasksSectionSettings
    }]
}];

const entityName = EntityType.Project;
const sourceTypesWithAssignmentsByDay = new Set([SourceType.Ppmx, SourceType.Spo]);
const tasksWorkloadDefaultTimeframe: ITimeframe = { 
    start: new Date().addDays(-1 * DAYS_IN_WEEK), 
    end: new Date().addDays(3 * DAYS_IN_WEEK) 
}

export class ProjectTasksList extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { activeSourceInfo: PpmxConnection };
    }

    componentWillMount() {
        this.props.warningsTypeMapsActions.loadWarningsTypeMap(entityName);
        if (!this.props.entity || this.props.entity.id !== this.props.match.params.id || isLiteModel(this.props.entity)) {
            this.props.projectsActions.loadProject(this.props.match.params.id);
        } else if (this.props.entity) {
            this._handleConnection(this.props);
        }
        this.props.timeTrackingActions?.setActiveResource(this.props.user.resource?.id);
    }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.match.params.id != this.props.match.params.id) {
            this.props.projectsActions.loadProject(nextProps.match.params.id);
        }
        if (nextProps.entity && (this._isConnectionIdChanged(this.props, nextProps) || nextProps.entity?.id !== this.props.entity?.id)
            || (this.props.isLoading && !nextProps.isLoading)) {
            this._handleConnection(nextProps);
        }
        if (nextProps.entity && (isWorkloadSourceChanged(this.props, nextProps) || nextProps.entity?.id !== this.props.entity?.id)
            || (this.props.isLoading && !nextProps.isLoading)) {
            this._handleWorkloadData(nextProps);
        }

        if (nextProps.user.resource?.id !== this.props.user.resource?.id) {
            this.props.timeTrackingActions?.setActiveResource(nextProps.user.resource?.id);
        }
    }

    private _isConnectionIdChanged(props: Props, nextProps: Props): boolean {
        if (!props.entity || !nextProps.entity) {
            return false;
        }
        const prevConnectionId = getSourceInfoFromUrl(props.entity, props.location).connectionId;
        const nextConnectionId = getSourceInfoFromUrl(nextProps.entity, nextProps.location).connectionId;
        return prevConnectionId != nextConnectionId;
    }

    private _handleConnection = (props: Props, isRefresh?: boolean) => {
        if (!props.entity) {
            return;
        }
        const activeSourceInfo = getSourceInfoFromUrl(props.entity, props.location);

        if (activeSourceInfo) {
            this.setState({ activeSourceInfo }, () => {
                props.projectsActions.loadTasks(props.entity!.id, activeSourceInfo.type, activeSourceInfo.connectionId, isRefresh);
                props.groupsActions.load(this.props.match.params.id, activeSourceInfo.connectionId);
                this.loadConnectionConfiguration(activeSourceInfo);
                props.timeReportingPeriodsActions.loadPeriods();
                props.projectsActions.loadAssignees(props.entity!.id, activeSourceInfo.connectionId, isRefresh);
            })
        }
    }

    private _handleWorkloadData = (props: Props, isRefresh?: boolean) => {
        if (!props.entity) {
            return;
        }
        const activeSourceInfo = getSourceInfoFromUrl(props.entity, props.location);

        if (activeSourceInfo) {
            this.setState({ activeSourceInfo }, () => {
                if(this._isWorkloadView(props)) {
                    this._loadByDays(props, activeSourceInfo.connectionId, isRefresh, true);
                }
            })
        }
    }

    private _isWorkloadView = (props: Props) => {
        const activeSourceInfo = getSourceInfoFromUrl(props.entity, props.location);
        return !!activeSourceInfo
            && sourceTypesWithAssignmentsByDay.has(activeSourceInfo.type)
            && getViewTypeFromUrl(props.entity, props.location) === Views.Usage.toLowerCase();
    }

    private _sharesRequestedFor = new Set<string>();

    // Bug 17380 – what each assignee holds of a task's Effort, summed from its persisted assignment rows. The
    // scheduling rules INFER it when it is absent, which cannot answer every state (see duration.storedSharesById).
    // The WORKLOAD view already holds every row, so read them there for free; anywhere else the first derivation that
    // wants them fetches THAT TASK's alone — which is panel open, since that is when the panel first derives. Until
    // it lands the rules fall back to inferring, so the preview corrects itself on the next render rather than
    // blocking on a fetch (the derivation is synchronous, per render).
    private _assignmentShares = (taskId: string): Dictionary<number> | undefined => {
        const rows = this.props.entity?.assignmentByDays;
        if (rows?.length) {
            const shares: Dictionary<number> = {};
            for (const row of rows) {
                const id = row.attributes.Task?.id === taskId ? row.attributes.Resource?.id : undefined;
                if (id) {
                    shares[id] = (shares[id] ?? 0) + (row.attributes.Effort ?? 0);
                }
            }
            if (Object.keys(shares).length > 0) {
                return shares;
            }
        }
        this._requestAssignmentShares(taskId);
        return this.state.assignmentShares?.[taskId];
    }

    private _requestAssignmentShares = (taskId: string) => {
        const { entity } = this.props;
        const connectionId = this.state.activeSourceInfo?.connectionId;
        if (!entity || connectionId === undefined || this._sharesRequestedFor.has(taskId)) {
            return;
        }
        this._sharesRequestedFor.add(taskId);
        // Deferred: the derivation that asks for the shares runs inside the panel's RENDER, and resolving a fetch
        // straight into setState from there updates the component mid-render.
        globalThis.setTimeout(() => fetchTaskAssignmentShares(entity.id, connectionId, taskId)
            .then(shares => this.setState(prev => ({ assignmentShares: { ...prev.assignmentShares, [taskId]: shares } }))), 0);
    }

    private _loadByDays = (props: Props, connectionId: string, isRefresh?: boolean, withBaselines?: boolean) => {
        props.projectsActions.loadAssignmentByDays(props.entity!.id, connectionId, isRefresh);
        props.projectsActions.loadTaskByDays(props.entity!.id, connectionId, isRefresh);
        if (withBaselines) {
            props.projectsActions.loadTaskBaselineByDays(props.entity!.id, connectionId, isRefresh);
        }
    }

    private loadConnectionConfiguration = (activeSourceInfo?: ISourceInfo<any>) => {
        if (activeSourceInfo?.type === SourceType.MondayCom) {
            this.props.mondayComActions.loadConnectionConfiguration(activeSourceInfo.connectionId, activeSourceInfo.sourceData.boardId, activeSourceInfo.sourceData.subItemBoardId);
        }
    }

    private _onTaskRecalculationFinished = (...taskIds: string[]) => {
        const entity = this.props.entity;
        if (!entity) {
            return;
        }
        const loaded = new Set((entity.tasks || []).map(_ => _.id));
        const connectionId = this.state.activeSourceInfo.connectionId;
        const matched = taskIds.filter(_ => loaded.has(_));
        matched.forEach(id => this.props.projectsActions.refreshTask(entity.id, id, connectionId));

        if (matched.length && this._isWorkloadView(this.props)) {
            this._loadByDays(this.props, connectionId, true);
        }
    };

    public render() {
        const { isLoading, entity, warnings, projectsActions } = this.props;

        const events = [{
            name: EventType.ProjectTaskUpdated,
            callback: (projectId: string) => {
                if(entity?.id === projectId) {
                    this._handleConnection(this.props, true);
                    this._handleWorkloadData(this.props, true);
                    this.props.projectsActions.refreshProjectTaskCalculation(EntityType.Project, projectId);
                    this.props.notificationsActions.pushNotification({ message: "Reloading tasks..." });
                }
            }
        },
        {
            name: EventType.ProjectTaskUpdateFailed,
            callback: (projectId: string) => {
                if(entity?.id === projectId) {
                    this.props.notificationsActions.pushNotification({ message: "Tasks update failed.", type: Notifications.NotificationType.Error });
                }
            }
        },
        {
            name: EventType.TaskRecalculationFinished,
            callback: this._onTaskRecalculationFinished
        }]

        return <DetailsSpinner isLoading={isLoading}>
            { entity && <ProjectHeader
                entity={entity}
                navigateToDetails
                hideWarnings
                disableChangeView
                actions={{
                    openConfigurationPanel: this.openConfigurationPanel,
                    updateImage: this.updateImage,
                    removeImage: this.removeImage,
                    setFavorite: this.setFavorite,
                    cloneProject: this.cloneProject,
                    removeProject: this.removeProject,
                    archiveProject: this.props.hasArchiveProjects ? this.archiveProject : undefined,
                    updateSettings: this.updateSettings,
                    setProjectBaseline: this.setProjectBaseline,
                    attachmentsActions: buildAttachmentActions(entity.id, this._getAnalyticsProps(), projectsActions),
                    layoutActions: {
                        viewLayout: this.viewLayout
                    }
                }}
            ></ProjectHeader>}
            { entity && <WithSignalR events={events}>
                    <SectionsContainer
                        key="sections"
                        entity={entity}
                        entityType={EntityType.Project}
                        hideSideBar
                        getSections={() => sections}
                        warnings={warnings}
                        controlsConfig={this._buildControlsConfigurations()}/>
                </WithSignalR>}
            { entity && this.state.isCofigurationPanelOpen &&
                <ExternalEpmConnectControl
                    entity={entity}
                    onDismiss={() => this.setState({ isCofigurationPanelOpen: false })}
                />
            }
            {!!this.state.scheduleToCopy && entity &&
                <CopyScheduleConfirmationDialog
                    projects={[entity]}
                    sourceType={this.state.scheduleToCopy}
                    onConfirm={() => this.props.projectsActions.copyToPpmxSchedule([this.props.entity!.id], this.state.scheduleToCopy!)}
                    onDismiss={() => this.setState({ scheduleToCopy: undefined })} />
            }
        </DetailsSpinner>;
    }

    private _getAnalyticsProps = () => ({ user: this.props.user, parentType: EntityType.Project })
    
    private _buildControlsConfigurations = (): IConfiguration => {
        const { groups, calendar, entity, extensions, resources, calendarsById, shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay } = this.props;
        const { activeSourceInfo } = this.state;

        return {
            ['TasksSummaryControl']: {
                datacontext: {
                    activeSourceInfo: activeSourceInfo
                },
            },
            ['TasksControl']: {
                settingsBuilder: settings => viewTypeSettingsBuilder(
                    mergeDefault({
                        timeline: { styleSettingValues: { showBaseline: true, showTimeWithDate: false, showActualDates: false, showCriticalPath: false } },
                        usage: {
                            displayFields: [nameof<ITaskAttrs>("Name")],
                            grouping: 'Task',
                            quantization: Quantization.days,
                            timeframe: tasksWorkloadDefaultTimeframe
                        },
                    }, settings),
                    ViewTypeViews.TaskControl.default),
                headerRender: buildUrlViewTypeHeaderRender(ViewTypeViews.TaskControl),
                extensions: (entity?.isEditable || entity?.canCollaborate) ? extensions : [],
                editProps: {
                    elementCustomRender: rendersBuilder(entity!, groups || [], calendar!, resources, calendarsById, !!entity?.settings.useResourceCalendar, this._buildTaskUrl, () => this.props.entity?.tasks, shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay),
                    customFieldValidator: validatorsBuilder(calendar!, resources, calendarsById, !!entity?.settings.useResourceCalendar, () => this.props.entity?.tasks, shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay),
                    deriveDisplayAttributes: buildDeriveDisplayAttributes(entity!, calendar!, resources, calendarsById, !!entity?.settings.useResourceCalendar, () => this.props.entity?.tasks, shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay, this._assignmentShares),
                    buildSavePayload: buildTaskSavePayload(entity!, calendar!, resources, calendarsById, !!entity?.settings.useResourceCalendar),
                },
                inlineEditProps: {
                    elementCustomRender: inlineRendersBuilder(entity!, groups || [], calendar!, resources, calendarsById, !!entity?.settings.useResourceCalendar, this._buildTaskUrl, () => this.props.entity?.tasks, shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay),
                    customFieldValidator: inlineValidatorsBuilder(calendar!, resources, calendarsById, !!entity?.settings.useResourceCalendar, () => this.props.entity?.tasks, this.props.taskFields, shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay),
                },
                datacontext: {
                    calendar: calendar,
                    calendarsById,
                    readOnlyFields: (task: ITask) => getTaskReadonlyFields(task, this.props.insights, entity?.insights.taskStatusCalculationDisabled),
                    groups,
                    activeSourceInfo: activeSourceInfo,
                    fakeFields: activeSourceInfo.type === SourceType.Ppmx ? [...BaselineFakeFields, CalculationModeFakeField, TaskTypeFakeField, IsSummaryFakeField] : [IsSummaryFakeField],
                },
                actions: {
                    buildNew: this.buildNewExternalTask,
                    create: this.createTask,
                    update: this.updateTask,
                    bulkUpdate: this.updateTasks,
                    bulkCreate: this.createTasks,
                    dragEntities: this.dragTasks,
                    setBaseline: this.setBaseline,
                    remove: this.removeExternalTasks,
                    updateUIControl: this.updateUIControl,
                    refreshEntity: this.refreshEntity,
                    exportToFile: this.exportSubEntitiesToFile,
                    importFromFile: this.importSubEntitiesFromFile,
                    createGroup: this.createGroup,
                    updateGroup: this.updateGroup,
                    removeGroup: this.removeGroup,
                    reorderGroups: this.reorderGroups,
                    reportTime: this.reportTime,
                    indent: this.indentTasks,
                    outdent: this.outdentTasks,
                    rollupTasks: this.rollupTasks,
                    applyCalendars: this.applyCalendars,
                    updateCalculationMode: this.changeCalculationMode,
                    updateTaskType: this.changeTaskType,
                    updateEffortDriven: this.changeEffortDriven,
                    copyToPpmxSchedule: this.copyToPpmxSchedule,
                    updateAssignmentsByDay: this.updateAssignmentsByDay,
                    saveTaskFormFields: this.saveTaskFormFields
                }
            }
        }
    }

    private viewLayout = (layout?: Metadata.Layout) => {
        this.props.layoutsActions.viewLayout(layout?.id);
    }

    private saveTaskFormFields = (sourceType: SourceType, fields: string[]) => {
        const layout = getEditedLayout(this.props.layouts);
        const scheduleControl = findScheduleControl(layout?.sections);
        if (!layout || !scheduleControl) {
            this.props.notificationsActions.pushNotification({
                message: "Unable to save the task form configuration: the layout has no Tasks section.",
                type: Notifications.NotificationType.Error
            });
            return;
        }

        this.props.projectsActions.partialUpdateLayoutUIControl(
            scheduleControl.sectionId,
            scheduleControl.uiControlId,
            { propertyPath: [TASK_FORM_SETTINGS, SourceType[sourceType]], value: fields },
            layout.id);
        this.props.notificationsActions.pushNotification({ message: `Task form configuration for layout '${layout.name}' is saved.` });
    }

    private openConfigurationPanel = () => {
        this.setState({ isCofigurationPanelOpen: true });
    }

    private cloneProject = () => {
        this.props.projectsActions.cloneProject(this.props.entity!.id);
        this.props.notificationsActions.pushNotification({ message: 'Project is cloned', type: Notifications.NotificationType.Info });
    }

    private removeProject = () => {
        this.props.projectsActions.removeProjects([this.props.entity!.id], true);
    }

    private archiveProject = () => {
        this.props.projectsActions.archiveProjects([this.props.entity!.id], true);
    }

    private setProjectBaseline = (setProjectBaseline: boolean, setTasksBaseline: boolean, setKeyDatesBaseline: boolean) => {
        this.props.projectsActions.setProjectBaseline(this.props.entity!.id, setProjectBaseline, setTasksBaseline, setKeyDatesBaseline);
    }

    private updateSettings = (data: ProjectsListStore.ProjectSettingsUpdateData): void => {
        this.props.projectsActions.updateSettings(this.props.entity!.id, data, () => {
            const connectionId = getSourceInfoFromUrl(this.props.entity, this.props.location).connectionId;
            if (connectionId == ppmxTaskConnectionId) {
                this.props.projectsActions.loadTasks(this.props.entity!.id, this.state.activeSourceInfo.type, connectionId, true);
            }
            if (data.calculateCompletedWorkBasedOnReportedTime) {
                this.props.projectsActions.runTaskCompletedWorkRecalculation(this.props.entity!.id);
            }
        });
        this.props.notificationsActions.pushNotification({ message: `Project settings have been changed.` });
    }

    private updateImage = (logo: File) => {
        this.props.projectsActions.updateImage(this.props.entity!.id, logo);
    }

    private removeImage = () => {
        this.props.projectsActions.removeImage(this.props.entity!.id);
    }

    private setFavorite = (isFavorite: boolean) => {
        this.props.projectsActions.setFavorite(this.props.entity!.id, isFavorite);
    }
    private buildNewExternalTask = (): ITask => {
        const group = this.props.groups?.find(_ => _.isDefault) || this.props.groups?.[0];
        let startDate = toDate(this.props.entity?.attributes.StartDate)?.getBeginOfDay();
        const today = new Date().getBeginOfDay();
        if (!startDate || startDate < today) {
            startDate = today;
        }
        const durationDays = 1;
        const dueDate = calculateDueDate(startDate, durationDays, this.props.calendar!, [this.props.calendar!])
        const statusDescriptor = StatusDescriptorFactory.createStatusDescriptorFor(EntityType.Task, this.props.taskFields)!;
        return {
            sourceType: SourceType.Ppmx,
            isAutoMode: this.props.entity?.settings.isTaskAutoCalculationMode,
            taskType: this.props.entity?.settings.taskType,
            attributes: {
                Group: group && { id: group.id, name: group.name, color: group.color },
                StartDate: startDate.setDayStart(this.props.calendar!).toUniversalIsoDateTimeString(),
                DueDate: dueDate.toUniversalIsoDateTimeString(),
                Duration: durationDays,
                Progress: 0,
                Status: statusDescriptor.getCategoryDefaultStatusValue(StatusCategory.NA)
            },
            externalData: {},
            hierarchy: {}
        } as ITask;
    }
    private createTask = (data: ICreationData, withByDays?: boolean, options?: UpdateOptions) => {
        this.props.projectsActions.createTask(this.props.entity!.id, this.state.activeSourceInfo.connectionId, data, withByDays, options);
    }
    private updateTask = (id: string, changes: Partial<ITaskAttrs>, reloadByDays?: boolean, options?: UpdateOptions) => {
        return this.updateTasks([{ id, attributes: changes }], reloadByDays, options);
    }
    private updateTasks = (items: IPatch<ITask>[], reloadByDays?: boolean, options?: UpdateOptions) => {
        return this.props.projectsActions.updateTasks(this.props.entity!.id, this.state.activeSourceInfo.connectionId, items, !!reloadByDays, options);
    }
    private createTasks = (items: ICreationData[], options?: UpdateOptions) => {
        this.props.projectsActions.createTasks(this.props.entity!.id, this.state.activeSourceInfo.connectionId, items, options);
    }
    private dragTasks = (ids: string[], groupId?: string, insertBeforeId?: string) => {
        if (!groupId) {
            return;
        }
        this.props.projectsActions.dragTasksToGroup(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids, groupId, insertBeforeId);
    }
    private setBaseline = (ids: string[]) => {
        this.props.projectsActions.setBaseline(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids);
    }
    private removeExternalTasks = (ids: string[]) => {
        this.props.projectsActions.removeTasks(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids);
    }
    private updateUIControl = (): void => {
        //this.props.projectsActions.updateUIControl(this.props.entity!.id, sectionId, uiControlId, settings);
    }
    private refreshEntity = () => {
        this._handleConnection(this.props);
    }
    private exportSubEntitiesToFile = (subentityType: EntityType, pluralSubentityTypeLabel: string, fields: string[], ids: string[], suggestedIds: string[], viewType: Views, showTime?: boolean) => {
        const exportColumns = [...fields];
        if (!exportColumns.find(_ => _ === nameof<ITaskAttrs>("Group"))) {
            exportColumns.push(nameof<ITaskAttrs>("Group"));
        }
        if (viewType === "Timeline") {
            if (!exportColumns.includes(nameof<ITaskAttrs>("StartDate"))) {
                exportColumns.splice(exportColumns.indexOf(nameof<ITaskAttrs>("Name")) + 1, 0, nameof<ITaskAttrs>("StartDate"));
            }
            if (!exportColumns.includes(nameof<ITaskAttrs>("DueDate"))) {
                exportColumns.splice(exportColumns.indexOf(nameof<ITaskAttrs>("StartDate")) + 1, 0, nameof<ITaskAttrs>("DueDate"));
            }
            if (!exportColumns.includes(nameof<ITaskAttrs>("Progress"))) {
                exportColumns.push(nameof<ITaskAttrs>("Progress"));
            }
            if (!exportColumns.includes(nameof<ITaskAttrs>("Predecessor"))) {
                exportColumns.push(nameof<ITaskAttrs>("Predecessor"));
            }
        }
        this.props.projectsActions.exportSubEntitiesToFile(
            this.props.entity!.id,
            subentityType,
            pluralSubentityTypeLabel,
            exportColumns,
            ids,
            suggestedIds,
            showTime);
    }
    private importSubEntitiesFromFile = (subentityType: EntityType, subentityCollectionName: string, file: File) => {
        this.props.projectsActions.importSubEntitiesFromFile(this.props.entity!.id, subentityType, subentityCollectionName, file);
    }

    private reportTime = (task: ITask, seconds: number, date: Date) => {
        if (!this.props.timeTrackingSettings.newTimeTrackingEnabled) {
            return;
        }

        const entry: CreateTimeTrackingEntryAttr = {
            Project: {
                id: this.props.entity!.id
            },
            Task: {
                id: task.id
            },
            Date: date.toDateOnlyString(),
            Duration: seconds / 60 / 60,
        };

        this.props.timeTrackingActions!.addTimeEntries([{ attributes: entry }], false);
    }

    private createGroup = (group: Metadata.IBaseGroupInfo) => {
        this.props.groupsActions.create(this.props.entity!.id, group);
    }
    private updateGroup = (group: Metadata.Group) => {
        this.props.groupsActions.update(this.props.entity!.id, group);
    }
    private removeGroup = (groupId: string) => {
        this.props.groupsActions.remove(this.props.entity!.id, groupId);
    }
    private reorderGroups = (groupIds: string[]) => {
        this.props.groupsActions.reorder(this.props.entity!.id, groupIds);
    }

    private _buildTaskUrl = (task: { id: string }): string => {
        const query = new URLSearchParams(this.props.location.search);
        query.set(EntityType.Task.toLowerCase(), task.id);

        return `${this.props.location.pathname}?${query.toString()}`;
    }

    private indentTasks = (ids: string[]) => {
        this.props.projectsActions.indentTasks(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids);
    }

    private outdentTasks = (ids: string[]) => {
        this.props.projectsActions.outdentTask(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids);
    }

    private rollupTasks = (ids: string[]) => {
        this.props.projectsActions.rollupTasks(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids);
    }

    private applyCalendars = (ids: string[]) => {
        this.props.projectsActions.applyCalendars(this.props.entity!.id, ids);
    }

    private changeCalculationMode = (isAutoMode: boolean, ids: string[], recalculation?: ModeSwitchRecalculation) => {
        this.props.projectsActions.changeCalculationMode(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids, isAutoMode, recalculation);
    }

    private changeTaskType = (taskType: TaskType, ids: string[]) => {
        this.props.projectsActions.changeTaskType(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids, taskType);
    }

    private changeEffortDriven = (effortDriven: boolean, ids: string[]) => {
        this.props.projectsActions.changeEffortDriven(this.props.entity!.id, this.state.activeSourceInfo.connectionId, ids, effortDriven);
    }

    private copyToPpmxSchedule = (sourceType: SourceType) => {
        this.setState({ scheduleToCopy: sourceType });
    }

    private updateAssignmentsByDay = (updates: AssignmentByDayUpdate[]) => {
        this.props.projectsActions.updateAssignmentsByDays(this.props.entity!.id, this.state.activeSourceInfo.connectionId, updates)
    }
}

interface IConfiguration extends Dictionary<IControlConfiguration> {
    TasksSummaryControl: TasksSummaryControl.IConfiguration;
    TasksControl: TasksControl.IConfiguration;
};

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        taskViewsActions: bindActionCreators(ViewsStore.actionCreators.forEntity(EntityType.Task), dispatch),
        groupsActions: bindActionCreators(ProjectsListStore.groupsCreators, dispatch),
        projectsActions: bindThunkActionCreators(ProjectsListStore.actionCreators, dispatch),
        timeReportingPeriodsActions: bindActionCreators(TimeReportingPeriodsStore.actionCreators, dispatch),
        notificationsActions: bindActionCreators(Notifications.actionCreators, dispatch),
        warningsTypeMapsActions: bindActionCreators(WarningsTypeMapsStore.actionCreators, dispatch),
        layoutsActions: bindActionCreators(LayoutsStore.actionCreators.forEntity(entityName), dispatch),
        userInterfaceActions: bindActionCreators(UserInterfaceActionCreators, dispatch),
        mondayComActions: bindActionCreators(MondayComStore.actionCreators, dispatch),
        timeTrackingActions: bindActionCreators(TimeTrackingActionCreators, dispatch),
    }
}

export default connect(
    (state: ApplicationState, ownProp: RouteComponentProps<{ id: string }>): StateProps => {
        const projectFields = state.fields[entityName];
        const taskFields = state.fields[EntityType.Task];
        const warningsTypeMap = state.warningsTypeMaps.maps[entityName] || { common: [], targeted: {} }
        const entity = state.projectsList.activeEntity && state.projectsList.activeEntity.id === ownProp.match.params.id
            ? state.projectsList.activeEntity
            : undefined;
        let warnings: IWarning[] = [];
        if (entity?.sections) {
            const tuple = warningService.filterByEntityConfiguration(warningService.getWarnings(entity), warningsTypeMap, entity.sections);
            warnings = tuple.warnings;
        }
        const sourceInfo = getSourceInfoFromUrl(entity, ownProp.location);
        
        return {
            entity,
            insights: state.tenant.insights,
            calendar: entity ? state.calendars.byId[entity.settings.calendar.id] : state.calendars.byId[state.calendars.defaultCalendarId],
            calendarsById: state.calendars.byId,
            shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay:
                entity?.settings?.shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay
                ?? true,
            resources: state.resources.byId,
            warnings,
            projectFields: projectFields.allIds.map(_ => projectFields.byId[_]),
            taskFields: taskFields.allIds.map(_ => taskFields.byId[_]),

            warningsTypeMap,
            groups: state.projectsList.groups.byId[ownProp.match.params.id]?.items,
            isLoading: state.calendars.isLoading || state.projectsList.isLoading || state.warningsTypeMaps.isLoading,
            hasArchiveProjects: Subscription.contains(state.tenant.subscription, PPMFeatures.ArchiveProjects),
            timeTrackingSettings: state.tenant.timeTracking.globalSettings,
            user: state.user,
            extensions: findExtension(state.extensions, EntityType.Project, ExtensionPageLocation.Views, EntityType.Task, sourceInfo.type),
            layouts: state.layouts[entityName],
        };
    },
    mergeActionCreators
)(ProjectTasksList);